/**
 * HelpMenu — header button: Help centre, What's new (with a dot when there
 * is a release this user hasn't seen), keyboard shortcuts.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LifeBuoy, Sparkles, Keyboard, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { hasUnseenRelease } from "@/content/releases";

export default function HelpMenu() {
  const [unseen, setUnseen] = useState(hasUnseenRelease());
  useEffect(() => {
    const update = () => setUnseen(hasUnseenRelease());
    window.addEventListener("eaze:releases-seen", update);
    return () => window.removeEventListener("eaze:releases-seen", update);
  }, []);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" aria-label={unseen ? "Help — new features available" : "Help"}>
          <LifeBuoy className="h-5 w-5" />
          {unseen && <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-[#4CAF50]" aria-hidden />}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuItem asChild>
          <Link to="/whats-new" className="flex items-center gap-2">
            <Sparkles className="h-4 w-4" /> What's new
            {unseen && <span className="ml-auto rounded-full bg-[#4CAF50] px-1.5 text-[10px] font-semibold text-white">NEW</span>}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/help" className="flex items-center gap-2">
            <BookOpen className="h-4 w-4" /> Help centre
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/help/keyboard" className="flex items-center gap-2">
            <Keyboard className="h-4 w-4" /> Keyboard shortcuts
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
